/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InboxEmail interface.
 */
export function instanceOfInboxEmail(value) {
    if (!('subject' in value) || value['subject'] === undefined)
        return false;
    if (!('datetime' in value) || value['datetime'] === undefined)
        return false;
    return true;
}
export function InboxEmailFromJSON(json) {
    return InboxEmailFromJSONTyped(json, false);
}
export function InboxEmailFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'subject': json['subject'],
        'datetime': (new Date(json['datetime'])),
        'from': json['from'] == null ? undefined : json['from'],
    };
}
export function InboxEmailToJSON(json) {
    return InboxEmailToJSONTyped(json, false);
}
export function InboxEmailToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'subject': value['subject'],
        'datetime': ((value['datetime']).toISOString()),
        'from': value['from'],
    };
}
